import { render } from "./PollStudents.vue?vue&type=template&id=086c621a&scoped=true"
import script from "./PollStudents.vue?vue&type=script&lang=js"
export * from "./PollStudents.vue?vue&type=script&lang=js"

import "./PollStudents.vue?vue&type=style&index=0&id=086c621a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086c621a"]])

export default __exports__